import styled from 'styled-components';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { Link } from 'components/Toolkit/Button/Link';
import { SubTitleImage } from 'components/Toolkit/SubTitleImage/SubTitleImage';

export interface KeyInfoCardProps {
  title: string;
  illustration?: string;
  linkText?: string;
  shouldTruncate?: boolean;
  withH1Tag?: boolean;
  sponsoredIllustration?: string;
  sponsoredIllustrationText: string;
  sponsoredIllustrationAltText?: string;
  isClickable?: boolean;
  onCardClick?: (identifier?: unknown) => void;
  identifier?: unknown;
  className?: string;
}

const KeyInfoCardContainer = styled.div<{ isClickable: boolean }>`
  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  padding: ${({ theme }) => theme.spacing.M16};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ isClickable }) => isClickable && 'cursor: pointer;'}
  gap: ${({ theme }) => theme.spacing.S8};
`;

function KeyInfoCard({
  title,
  illustration,
  linkText,
  shouldTruncate = false,
  withH1Tag,
  isClickable = false,
  onCardClick,
  sponsoredIllustration,
  sponsoredIllustrationText,
  sponsoredIllustrationAltText,
  identifier,
  className,
}: KeyInfoCardProps) {
  function handleCardClick() {
    if (onCardClick) {
      onCardClick(identifier);
    }
  }

  return (
    <KeyInfoCardContainer
      className={className}
      isClickable={isClickable}
      onClick={handleCardClick}
    >
      <InfoTitle
        withH1Tag={withH1Tag}
        title={title}
        illustration={illustration}
        listItems={[
          linkText && (
            <Link isFakeLink={true} fontSize="M14">
              {linkText}
            </Link>
          ),
        ]}
        shouldTruncate={shouldTruncate}
        variant="SMALL"
      />
      {sponsoredIllustration && (
        <SubTitleImage
          subTitle={sponsoredIllustrationText}
          imageUrl={sponsoredIllustration}
          imageAltText={sponsoredIllustrationAltText}
        />
      )}
    </KeyInfoCardContainer>
  );
}

export { KeyInfoCard };
